<template>
  <g>
    <path
      d="M22.5612 6.34226C22.3197 5.42031 21.6082 4.69423 20.7045 4.44782C19.067 4 12.5 4 12.5 4C12.5 4 5.93313 4 4.29548 4.44782C3.39182 4.69423 2.68012 5.42031 2.43876 6.34226C2 8.01333 2 11.5 2 11.5C2 11.5 2 14.9865 2.43876 16.6577C2.68012 17.5798 3.39182 18.3057 4.29539 18.5524C5.93304 19 12.4999 19 12.4999 19C12.4999 19 19.0669 19 20.7044 18.5524C21.6081 18.3058 22.3196 17.5798 22.5611 16.6578C23 14.9866 23 11.5001 23 11.5001C23 11.5001 23 8.01342 22.5611 6.34235"
      fill="#FF0000"
    />
    <path d="M9.875 14.5882L16 11.5002L9.875 8.41174V14.5882Z" fill="white" />
  </g>
</template>
